import React from "react";
import { Modal } from "react-bootstrap";
import successGif from "../../../assets/images/success.gif";
import "./paymentSuccessModal.css";

const PaymentSuccessModal = () => {
  return (
    <div className="paymentSuccessModal">
      <Modal
        animation={false}
        backdropClassName="onboarding-custom-backdrop"
        centered
        dialogClassName="custom-onboarding-modal paymentSuccessDialog"
        show={true}
      >
        <Modal.Body className="paymentSuccessModalBody figma-drop-shadow">
          <div className="onboardingCopyTradeContent">
            <h2 className="title">Payment successful!</h2>
            <p className="desc">Please hold</p>
            {/* <img src={setupImage} alt="Setup Icon" className="setupImage" /> */}
            <img src={successGif} className="success-loader" alt="loaderGif" />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default PaymentSuccessModal;
